<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8qS9t8/cover.jpeg?1684306038633" alt="This image is the cover for the book Talking in Code, Talking in Code"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Talking in Code, Talking in Code
      </h1>
      <p class="bookDescription body article font2">
        <p>Some things crumble under pressure. Others are tempered by it instead. For three former soldiers, a tragedy might be the catalyst that binds them together—stronger than ever.</p> <p>Richard Horn and Timothy Davenport met in the SEALs twenty years ago and have been lovers ever since. Now running their own paramilitary organization, Strike Force Omega, they work in the shadows to protect their country and its people. When Tim falls for Eric Newton, a deadly sniper and strategist on their team, Richard accepts that Tim’s heart is big enough for two men. He respects, admires, and even desires Eric enough to accept him into their relationship—and their bed—but he’s never been fully a part of what Eric and Tim share.</p> <p>Then Eric is captured by terrorists and Tim is gravely injured in an op gone wrong, bringing Richard’s world crashing down around his ears. Even if he gets his men out alive, Eric must face the aftermath of months of physical and psychological torture—and without Tim to lean on, Eric’s PTSD is tearing him apart. Richard has to figure out the third leg of their triangle fast, or Tim won’t have a life to come back to.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ariel Tachna
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f1d8917